import branditRails from '../../../../api/brandit_rails'
import {
  setFeatureFlagsStatusAction,
  setFeatureFlagAction,
  setFeatureFlagsErrorsAction,
  clearFeatureFlagsErrorsAction
} from './featureFlags.actions'

export const checkFeatureFlag = ({ key }) => async (dispatch, getState) => {
  const cached = getState().featureFlags?.flags?.[key]
  if (cached !== undefined) return cached.enabled

  try {
    dispatch(setFeatureFlagsStatusAction('loading'))
    dispatch(clearFeatureFlagsErrorsAction())

    const { data } = await branditRails.get(`/feature_flags/${encodeURIComponent(key)}`)

    dispatch(setFeatureFlagAction({ key, enabled: data.enabled }))
    dispatch(setFeatureFlagsStatusAction('succeeded'))

    return data.enabled
  } catch (err) {
    dispatch(setFeatureFlagsStatusAction('failed'))
    dispatch(setFeatureFlagsErrorsAction({
      action: 'checkFeatureFlag',
      key,
      message: err.response?.data?.error || err.message
    }))

    dispatch(setFeatureFlagAction({ key, enabled: false }))
    return false
  }
}
